import React from "react";
import { CheckCircleIcon } from "@heroicons/react/24/outline";

export default function CheckOutSuccessScreen({
  jobTitle,
  checkInDate,
  checkOutDate,
  onDone,
}) {
  const safeCheckIn = checkInDate || new Date();
  const safeCheckOut = checkOutDate || new Date();

  const formattedCheckInTime = safeCheckIn.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  const formattedCheckOutTime = safeCheckOut.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const diffMs = safeCheckOut - safeCheckIn;
  const diffSecs = Math.max(0, Math.floor(diffMs / 1000));
  const h = Math.floor(diffSecs / 3600);
  const m = Math.floor((diffSecs % 3600) / 60);
  const s = diffSecs % 60;
  const totalDurationStr = `${String(h).padStart(2, "0")}h ${String(m).padStart(
    2,
    "0"
  )}m ${String(s).padStart(2, "0")}s`;

  return (
    <div className="text-center py-1 space-y-4 font-sans">
      <div className="text-emerald-500 mb-1">
        <CheckCircleIcon className="w-12 h-12 mx-auto animate-bounce text-emerald-500" />
      </div>

      <h2 className="text-base font-bold text-slate-900 tracking-tight">
        Successfully Checked Out
      </h2>

      <div className="bg-slate-50 border border-slate-200/80 p-3.5 rounded-2xl text-left space-y-2.5 shadow-xs">
        <div>
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">
            Job Site
          </p>
          <p className="text-xs font-bold text-slate-900">{jobTitle}</p>
        </div>
        <div className="grid grid-cols-2 gap-3 pt-1 border-t border-slate-200/60">
          <div>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">
              Check In
            </p>
            <p className="text-xs font-bold text-slate-700">{formattedCheckInTime}</p>
          </div>
          <div>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">
              Check Out
            </p>
            <p className="text-xs font-bold text-slate-700">{formattedCheckOutTime}</p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3 pt-2 border-t border-slate-200">
          <div>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">
              Total Time
            </p>
            <p className="text-xs font-black text-slate-900">{totalDurationStr}</p>
          </div>
          <div>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">
              Status
            </p>
            <span className="inline-flex items-center gap-1 rounded-full bg-slate-200 px-2.5 py-0.5 text-[10px] font-bold text-slate-700 border border-slate-300">
              Checked Out
            </span>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={onDone}
        className="w-full bg-slate-900 hover:bg-slate-800 py-3 text-xs font-bold text-white rounded-xl shadow-md transition-all duration-200 cursor-pointer active:scale-[0.98]"
      >
        Done
      </button>
    </div>
  );
}
